import { PaymentMethodsManager } from './PaymentMethodsManager';

export default PaymentMethodsManager;
